/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Currency } from './';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './';
import type { DeliverablePaymentStatus } from './';
import {
    DeliverablePaymentStatusFromJSON,
    DeliverablePaymentStatusFromJSONTyped,
    DeliverablePaymentStatusToJSON,
} from './';
import type { ProjectDeliverablePaymentResource } from './';
import {
    ProjectDeliverablePaymentResourceFromJSON,
    ProjectDeliverablePaymentResourceFromJSONTyped,
    ProjectDeliverablePaymentResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface FinancingBlockedPaymentResource
 */
export interface FinancingBlockedPaymentResource extends ProjectDeliverablePaymentResource {
    /**
     * 
     * @type {Date}
     * @memberof FinancingBlockedPaymentResource
     */
    expectedUpdateDate: Date;
}

/**
 * Check if a given object implements the FinancingBlockedPaymentResource interface.
 */
export function instanceOfFinancingBlockedPaymentResource(value: object): value is FinancingBlockedPaymentResource {
    if (!('expectedUpdateDate' in value) || value['expectedUpdateDate'] === undefined) return false;
    return true;
}

export function FinancingBlockedPaymentResourceFromJSON(json: any): FinancingBlockedPaymentResource {
    return FinancingBlockedPaymentResourceFromJSONTyped(json, false);
}

export function FinancingBlockedPaymentResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinancingBlockedPaymentResource {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ProjectDeliverablePaymentResourceFromJSONTyped(json, ignoreDiscriminator),
        'expectedUpdateDate': (new Date(json['expectedUpdateDate'])),
    };
}

export function FinancingBlockedPaymentResourceToJSON(value?: FinancingBlockedPaymentResource | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ProjectDeliverablePaymentResourceToJSON(value, true),
        'expectedUpdateDate': ((value['expectedUpdateDate']).toISOString().substring(0,10)),
    };
}

